import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class HistoryService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }


	loadHistoryData(startDate, endDate): Observable<any> {
		const startDate1 = startDate.concat(" 23:59:59")
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/asn/history/${startDate1}/${endDate}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}

}
